// Providing for correct ordering css files

// tailwind
import '@/styles/tailwind.css';

// mantine
import '@mantine/core/styles.layer.css';
import '@mantine/dates/styles.layer.css';
import '@mantine/notifications/styles.layer.css';

// slick-carousel
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

// local
import '@/styles/globals.css';
import '@/styles/mantine.css';
import '@/styles/media.css';
import '@/styles/progressbar.css';

export default function StylesProvider() {
  return null;
}
